import AbstractDevice from '../all/AbstractDevice';
import AndroidTvPlayerUtil from "./PlayerUtil";
import AndroidTvConfig from "./config";
import AndroidId from "../android/Id";
import AndroidPlayer from "./Player";
import AbstractHTML5Player from '../all/AbstractHTML5Player';
import AndroidKeys from "../stbkaon/Keys";
import AndroidNetworkStatus from "../android/NetworkStatus";
import AndroidTVSystem from "./System";
import settings from '../all/settings';
import WorkstationKeys from '../workstation/Keys';

class AndroidTvDevice extends AbstractDevice {
  constructor () {
    super(
      "androidtv",
      new AndroidId(),
      settings.use_dexie ? new AbstractHTML5Player() : new AndroidPlayer(),
      new AndroidTvPlayerUtil(),
      AndroidTvConfig,
      settings.use_dexie? new WorkstationKeys() : new AndroidKeys(),
      new AndroidNetworkStatus(),
      new AndroidTVSystem(),
      "androidtv"
    );
  }

  update_launcher(region, result){
    try {
      window.AndroidPlayerInterface.saveLauncher(region, JSON.stringify(result));
    }
    catch (e) {
      console.error("[Device.update_launcher]", e);
    }
  }
}

export default AndroidTvDevice;



// WEBPACK FOOTER //
// ./src/devices/androidtv/Device.js